import { render, staticRenderFns } from "./BoardNew.vue?vue&type=template&id=3a1fdb74&scoped=true"
import script from "./BoardNew.vue?vue&type=script&lang=js"
export * from "./BoardNew.vue?vue&type=script&lang=js"
import style0 from "./BoardNew.vue?vue&type=style&index=0&id=3a1fdb74&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a1fdb74",
  null
  
)

export default component.exports